export const REGIONS = ["Himachal", "Ladakh", "Kashmir", "Rajasthan", "Kerala", "Andaman"];

export const DURATION_BUCKETS = [
  { key: "short", label: "Short (3-5 Days)" },
  { key: "medium", label: "Medium (6-8 Days)" },
  { key: "long", label: "Long (9+ Days)" },
];

export const TIER_ORDER = ["silver", "silver_plus", "golden", "diamond"];

export const TIER_LABELS = {
  silver: "Silver",
  silver_plus: "Silver Plus",
  golden: "Golden",
  diamond: "Diamond",
};

export const TIER_BADGE_CLASSES = {
  silver: "bg-slate-100 text-slate-700 border border-slate-200",
  silver_plus: "bg-slate-100 text-slate-800 border border-slate-300",
  golden: "bg-[hsl(var(--brand-accent))]/25 text-slate-900 border border-[hsl(var(--brand-accent))]/50",
  diamond: "bg-sky-50 text-sky-900 border border-sky-100",
};

export const LEAD_STATUSES = ["New Lead", "Contacted", "Quoted", "Confirmed", "Closed"];

export const LEAD_STATUS_CLASSES = {
  "New Lead": "bg-sky-50 text-sky-900 border border-sky-100",
  Contacted: "bg-slate-100 text-slate-700 border border-slate-200",
  Quoted: "bg-[hsl(var(--brand-accent))]/25 text-slate-900 border border-[hsl(var(--brand-accent))]/50",
  Confirmed: "bg-emerald-50 text-emerald-900 border border-emerald-100",
  Closed: "bg-zinc-100 text-zinc-700 border border-zinc-200",
};

export function formatINR(amount) {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return "Price on Request";
  return `\u20b9${Math.round(amount).toLocaleString("en-IN")}`;
}

export function tourHasPricing(tour) {
  return tour?.price_mode === "fixed";
}

export function getAvailableTiers(tour) {
  if (!tour?.hotel_tiers) return [];
  return TIER_ORDER.filter((t) => tour.hotel_tiers[t]);
}

export function computeEstimate(tour, tierKey, paxCount) {
  if (!tour || !tierKey || !tour.hotel_tiers?.[tierKey]) return null;
  const tier = tour.hotel_tiers[tierKey];
  const perPersonRate = paxCount >= 4 ? tier.cost_4_pax : tier.cost_2_pax;
  if (perPersonRate === null || perPersonRate === undefined) return null;
  return { perPerson: perPersonRate, total: perPersonRate * paxCount };
}
